// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import { useQuery } from 'urql';

import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import { localize } from '@ta/common.i18n';

import LocationNameQuery from './LocationNameQuery.gql';
import styles from './SaveFromGeoRightRail.less';

type Props = {|
  /** */
  geoId: number,
|};

const SaveFromGeoRightRail = (props: Props) => {
  const { geoId } = props;

  const [{ error, data }] = useQuery({
    query: LocationNameQuery,
    variables: {
      locationId: geoId,
    },
  });

  const [animate, setAnimation] = React.useState(false);
  const [displayReady, setDisplayReady] = React.useState(false);

  React.useEffect(() => {
    setDisplayReady(true);

    setTimeout(() => {
      setAnimation(true);
    }, 1250);
  }, [setAnimation]);

  const SavesHeart = ({ index }) => (
    <div
      className={classNames('ui_icon_stacked', styles.save, {
        [`save_card${index}`]: index,
        [styles.animate]: animate,
      })}
    >
      <span className={classNames('ui_icon stacked heart-fill', styles.inner_icon)} />
      <span className={classNames('ui_icon stacked heart', styles.outer_icon)} />
    </div>
  );

  if (error) {
    return null;
  }

  if (data) {
    const { locations } = data;

    if (locations && locations.length > 0) {
      const location = locations[0];

      if (location) {
        const { name } = location;
        const sGeo = name || '';

        return (
          <div
            className={classNames('ui_card', styles.saves_educator, {
              [styles.display_ready]: displayReady,
            })}
          >
            <SavesHeart index={1} />
            <SavesHeart index={2} />
            <SavesHeart index={3} />
            <div className={styles.copy_container}>
              <div className={styles.copy_line1}>
                {localize('See_something_you_love_in_sGeo' /* See something you love in {0}? */, {
                  '0': sGeo,
                })}
              </div>
              <div className={styles.copy_line2}>
                {localize(
                  'cx_saves_educator_click_the_heart_on_hotels',
                ) /* Click the heart on hotels, things to do and more to save them for later. */}
              </div>
              <div
                className={classNames(styles.tripadvisor_logo, {
                  [styles.cx_brand_refresh]: featureIsEnabled('cx_brand_refresh_phase0'),
                })}
              />
            </div>
          </div>
        );
      }
    }
  }

  return null;
};

/** */
export default React.memo<Props>(SaveFromGeoRightRail);
